module.exports = __webpack_public_path__ + "fonts/notosans-light-web.dc718b4.ttf";